import apiClient from '../../../api-client';

export class NetworkDevicesService {
  public async getNetworkDevices(companyId: number) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/assets/network/devices`
      );
      return response.data;
    } catch (error) {
      throw new Error('error fetching network devices');
    }
  }

  public async generateNetworkConnection(
    companyId: number,
    deviceId: number,
    body: any
  ) {
    try {
      const response = await apiClient.post(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/assets/network/device/${deviceId}/connection`,
        { ...body }
      );
      return response.data;
    } catch (error) {
      throw new Error('error fetching network devices');
    }
  }

  public async getRtdHistory(deviceId: number, companyId: number) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/assets/network/device/${deviceId}/history/rtd`
      );
      return response.data;
    } catch (error) {
      throw new Error('error fetching rtd history');
    }
  }

  public async getDeviceVariables(
    deviceId: number,
    companyId: number,
    queryParams: any
  ) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/assets/network/device/${deviceId}/variables`,
        {
          params: queryParams,
        }
      );
      return response.data;
    } catch (error) {
      throw new Error('error fetching rtd history');
    }
  }

  public async getSpeedtestHistory(companyId: number) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/assets/network/history/speedtest`
      );
      return response.data;
    } catch (error) {
      throw new Error('error fetching rtd history');
    }
  }

  public async getAssetImageUrl(companyId: number, productModel: string) {
    try {
      const response = await apiClient.get(
        `${process.env.GATSBY_SSO_BACKEND_API_URL}/company/${companyId}/assets/images/${productModel}`
      );
      return response.data;
    } catch (error) {
      throw new Error('error fetching rtd history');
    }
  }

  public async getPublicIp() {
    return await apiClient.get('https://api.ipify.org/?format=json');
  }
}
